/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserShortInfo} from '../models/UserShortInfo';

export interface GetUserShortInfo$Request {
    userId: number;
}

export interface GetUserShortInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserShortInfoRequest = createAction<PayloadData<void, GetUserShortInfo$Request>>('GET_USER_SHORT_INFO__GET_USER_SHORT_INFO__REQUEST');
export const getUserShortInfoSuccess = createAction<PayloadData<UserShortInfo, GetUserShortInfo$Request>>('GET_USER_SHORT_INFO__GET_USER_SHORT_INFO__SUCCESS');
export const getUserShortInfoFailure = createAction<PayloadData<Error, GetUserShortInfo$Request, true>>('GET_USER_SHORT_INFO__GET_USER_SHORT_INFO__FAILURE');

export const getUserShortInfoActions = [
    getUserShortInfoRequest,
    getUserShortInfoSuccess,
    getUserShortInfoFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserShortInfo = (meta: GetUserShortInfo$Request, config?: GetUserShortInfo$Config) => {
    return {
        CALL_API: {
            types: getUserShortInfoActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users-short/${meta.userId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

